import { createSelector } from '@reduxjs/toolkit';
import { selectOfferTypeLabel } from './selectOfferTypeLabel';
import { selectOfferTypeOptions } from './selectOfferTypeOptions';
import { selectOfferTypeValue } from './selectOfferTypeValue';
import { selectDealType } from 'shared/selectors/jsonQuery';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { EPageType } from 'shared/types/page';
import { FDealType } from '../../../../packages/JsonQuery';
import { TButtonSize } from 'shared/types/filters';

export const selectOfferTypeFilter = createSelector(
  [selectOfferTypeLabel, selectOfferTypeOptions, selectOfferTypeValue, selectDealType, selectPageType],
  (
    label,
    options,
    value,
    dealType,
    pageType,
  ): {
    label: typeof label;
    options: typeof options;
    value: typeof value;
    size: TButtonSize;
  } => ({
    label,
    options,
    value,
    size: dealType === FDealType.RentDaily && pageType === EPageType.MAIN ? 'small' : 'default',
  }),
);
